import { render, staticRenderFns } from "./abnormalreceivingorder-list.vue?vue&type=template&id=85779576&scoped=true&"
import script from "./abnormalreceivingorder-list.vue?vue&type=script&lang=ts&"
export * from "./abnormalreceivingorder-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85779576",
  null
  
)

export default component.exports